import { useSyncExternalStore } from 'react';
import {
    isPreviewGuardActive,
    subscribePreviewActive,
} from '@/shared/services/previewGuard';

export const PREVIEW_LOCK_NOTE_ID = 'preview-lock-note';
export const PREVIEW_LOCK_REASON =
    'Turned off while you are viewing the site as another role.';

/**
 * Whether write actions are turned off by a role preview. The API client
 * refuses the request regardless; this lets a form say so up front. It reads
 * the same flag the client uses, so it needs no auth provider around it.
 */
export function usePreviewLock() {
    return useSyncExternalStore(subscribePreviewActive, isPreviewGuardActive);
}
